module.exports = __webpack_public_path__ + "img/free.bf8dd508.jpg";